import React from 'react';
import { IMatrixMessage } from '../../../client/message/types';

interface RoomServerAclMessageProps {
  message: IMatrixMessage;
  className?: string;
}

export const RoomServerAclMessage = ({ message, className = '' }: RoomServerAclMessageProps) => {
  return (
    <div className={`room-server-acl-message ${className}`} style={{ color: '#ffb300', padding: '8px 0' }}>
      房间服务器访问控制已变更
    </div>
  );
}; 